import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdentityService {
  public authConfig: AuthConfig = {
    issuer: environment.issuer,
    redirectUri: environment.domainLogin + '/callback',
    clientId: environment.clientId,
    responseType: 'code',
    scope:
      'openid profile rpa_mobile rpa rpa_configuration rpa_intervention rpa_residence rpa_resident offline_access rpa_offeredservice rpa_incidentaccident udata_public rpa_workshift',
    postLogoutRedirectUri: environment.domainLogin + '/login',
    showDebugInformation: true,
    requireHttps: environment.production,
    useSilentRefresh: false,
    sessionChecksEnabled: !environment.skipIssuerCheck,
    skipIssuerCheck: environment.skipIssuerCheck,
    timeoutFactor: 0.75,
    disablePKCE: false
  };

  constructor(
    private oauthService: OAuthService
  ) {
    this.oauthService.configure(this.authConfig);
    // No client-side signature check on the ID token: with authorization code + PKCE the token
    // comes from the token endpoint over TLS, never through the address bar, so OIDC Core
    // 3.1.3.7 allows relying on TLS server authentication instead. What guards the data is the
    // ACCESS token, validated where it is spent (AddJwtBearer in the host Program.cs, and again
    // by the RPA APIs the token is replayed to). Dropping this removes angular-oauth2-oidc-jwks
    // and its unmaintained jsrsasign dependency. Revisit only if this app ever moves to the
    // implicit flow. Same decision as UData.RPA.Web.Hub.

    this.oauthService.events.subscribe(async (e) => {
      if (e.type === 'token_received') {
      } else if (e.type === 'token_error') {
      } else if (e.type === 'code_error') {
      } else if (e.type === 'discovery_document_loaded') {
      } else if (e.type === 'discovery_document_load_error') {
      } else if (e.type === 'token_expires') {
        await this.refreshToken();
      } else if (e.type === 'silent_refresh_error') {
        this.oauthService.initLoginFlow();
      } else if (e.type === 'token_refreshed') {
        //const token = this.oauthService.getAccessToken();
        //this.authenticationService.login(token);
      } else if (e.type === 'invalid_nonce_in_state') {
        console.log('Nonce error detected. Reloading the page.');
        window.location.reload();
      }
      //      console.log(e);
    });   
  }

  public async login() : Promise<void> {
    sessionStorage.setItem("FirstLogin", "1");
    await this.ensureDiscoveryDocumentLoaded();
    this.oauthService.initLoginFlow();
  }

  public async logout(): Promise<void> {
    if (await this.isLoggedIn()) {
      this.oauthService.logOut();
    }
    sessionStorage.clear();
  }

  public async isLoggedIn(): Promise<boolean> {
    await this.ensureDiscoveryDocumentLoaded();
    return this.oauthService.hasValidAccessToken();
  }

  public get identityClaims() {
    const claims = this.oauthService.getIdentityClaims();
    return claims ? claims : null;
  }

  public get accessToken() {
    return this.oauthService.getAccessToken();
  }

  private async ensureDiscoveryDocumentLoaded(): Promise<void> {
    if (!this.oauthService.discoveryDocumentLoaded || this.oauthService.loginUrl == '' || this.oauthService.tokenEndpoint == '') {
      await this.oauthService.loadDiscoveryDocumentAndTryLogin();
    }
  }

  private async refreshToken() : Promise<void> {
    await this.ensureDiscoveryDocumentLoaded();
    await this.oauthService.refreshToken();
  }
}
